'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CustomSwiper = function () {
  function CustomSwiper(element) {
    _classCallCheck(this, CustomSwiper);

    this.element = element;
    this.element.classList.add('is-activated');
    this.slideLength = this.element.querySelectorAll('.js-collectionList_node').length;
    this.slidesPerView = 4;
    this.slidesPerGroup = 4;
    this.options = {
      speed: 600,
      slidesPerView: this.slidesPerView,
      slidesPerGroup: this.slidesPerGroup,
      grid: {
        rows: 1
      },
      spaceBetween: 15,
      navigation: {
        nextEl: this.element.querySelector('.swiper-button-next'),
        prevEl: this.element.querySelector('.swiper-button-prev')
      },
      pagination: {
        el: '.js-collectionPagenation',
        type: 'fraction'
      }
    };
    this.swiper = new Swiper(this.element, this.options);

    window.addEventListener('load', this.updateOptions.bind(this));
    window.addEventListener('resize', this.updateOptions.bind(this));
  }

  _createClass(CustomSwiper, [{
    key: 'updateOptions',
    value: function updateOptions() {
      if (ONIBUS && ONIBUS.data && ONIBUS.data.$MQ === 'PORTRAIT') {
        // スマホでも1行横スワイプ（2段表示なし）
        this.swiper.params.grid = {
          rows: 1
        };
        this.swiper.params.slidesPerView = 2;
        this.swiper.params.slidesPerGroup = 2;
        this.swiper.params.speed = 400;
        this.swiper.update();
      } else {
        this.swiper.params.slidesPerView = 4;
        this.swiper.params.slidesPerGroup = 4;
        this.swiper.params.speed = 600;
        delete this.swiper.params.grid;
        this.swiper.update();
      }
    }
  }]);

  return CustomSwiper;
}();

document.addEventListener('DOMContentLoaded', function () {
  var collectionLists = document.querySelectorAll('.js-collectionList');
  collectionLists.forEach(function (element) {
    if (element.classList.contains('is-activated')) return;
    new CustomSwiper(element);
  });
});
